export class B2CUser {
    businessPhones: Array<any>;
    displayName: string;
    givenName: string;
    id: string;
    mail: string;
    surname: string;
    userPrincipalName: string;
    oDataType: string;
    passwordProfile: { password: string };
}

export class AddB2CUser {
    organisationID: string;
    roleId: string;
    userEmail: string;
    firstName: string;
    lastName: string;
}
